import { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, RouterProvider } from 'react-router-dom';
import { auth, database } from './firebase/firebase';
import { ref, get, set, push } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import { getRouter, maintenanceRouter, roleBasedRoutes, router } from './router/router';
import { ThemeProvider } from '@mui/material/styles';
import { useAppContext } from './contexts/appContext';
import useContentful from './hooks/useContentfull';
import { Box, CircularProgress } from '@mui/material';



function App() {

  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const { muiTheme, user: userContext, loadingUser } = useAppContext();


  const addTestRoles = async () => {
    try {
      // Test roles data
      const testRoles = [
        {
          roles_name: 'Admin',
          roles_description: 'System administrator with full privileges',

        },
        {
          roles_name: 'Factory',
          roles_description: 'Production facility manager',

        },
        {
          roles_name: 'Wholesaler',
          roles_description: 'Distributor/wholesaler',

        },
        {
          roles_name: 'Store',
          roles_description: 'Retail store/shop',

        },
        {
          roles_name: 'Certifier',
          roles_description: 'Certification authority',

        },
        {
          roles_name: 'Customer',
          roles_description: 'End consumer',

        }
      ];

      // Add roles to Firebase
      await Promise.all(testRoles.map(role => {
        const newRef = push(ref(database, 'roles'));
        return set(newRef, role);
      }));
      alert('Test data added successfully!');
    } catch (error) {
      console.error("Error adding test roles:", error);
      alert("Failed to add test data");
    } finally {
    }
  };
  /*
    <div>
      <button onClick={addTestRoles}>Add Test Roles</button>
    </div>*/
    

  // if (loadingUser) {
  //   return (
  //     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // Si en maintenance, vérifier si l'utilisateur tente d'accéder à la route admin spéciale
  if (maintenanceMode) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={maintenanceRouter} />
      </Suspense>
    );
  }



  return (
    <ThemeProvider theme={muiTheme}>
      <Suspense
      // fallback={
      //   <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      //     <CircularProgress />
      //   </Box>
      // }
      >
        <RouterProvider router={getRouter(userContext?.role)} />
      </Suspense>
    </ThemeProvider>
  );
}

export default App;

